// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"82fd830f","191":"0c72fb1a","218":"7e61d51a","311":"ad750408","407":"fc4c569a","639":"8d1d3bdb","674":"7bb7b27e","720":"f643cf14","722":"83401bc6","724":"0013738c","737":"e667bec0","777":"2f61dc8c","850":"9fa080a4"}[chunkId] + ".chunk.js";
};